/* @jsx mdx */
  import React from 'react'
  import { mdx } from '@mdx-js/react'
  /* @jsx mdx */
import { Image } from 'components/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Erika est maintenant une vache. Elle est fécondée par un technicien inséminateur ou un
vétérinaire. La vache est généralement imprégnée dès le premier essai. Un seul taureau
peut avoir des dizaines de milliers de descendants par année. 285 jours plus tard, Erika
met bas son premier veau dans un box de vêlage séparé. Il sera immédiatement isolé de sa
mère. Erika est une vache primipare. On compte en Suisse quelques 560’000 vaches
laitières - c’est le cheptel le plus bas depuis la fin des années 80. Chacune de ces
bêtes fait un veau chaque année. Car pour qu’elles puissent donner du lait, les vaches
doivent vêler régulièrement. Erika donne environ 25 litres de lait par jour. Suite à
l’intensification de la sélection, le rendement laitier de la vache suisse a augmenté de
30% en trois décennies.`}</p>
    <Image file={['milchproduktion-fr-01.png', 'milchproduktion-fr-02.png']} title='Rendement laitier' subtitle='par vache et par an en kg, 2016' source='Source: Commission européenne, Office fédéral de l’agriculture, Département fédéral de l’agriculture' mdxType="Image" />
  
L’industrie laitière est le principal pilier de l’économie
agricole. Il représente 20% des activités de ce secteur. Actuellement il existe en
Suisse encore quelques 19’500 exploitations agricoles produisant du lait, dont seules
10% produisent en bio. Chaque jours, deux fermes arrêtent de traire. Elles passent à la
production de viande parce ce que le prix du lait est trop bas.
    <Image file={['milchpreis-fr-01.png', 'milchpreis-fr-02.png']} title='Évolution du prix du lait' subtitle='en centimes par kilo' source='Source: Office fédéral de l’agriculture' mdxType="Image" />
    <p>{`Le lait d’Erika sert surtout à fabriquer du fromage (43%). Pour obtenir un kilo de
fromage dur, il faut environ 13 litres de lait. Les 57% restants sont transformés en
beurre (15%), poudre de lait et dérivés (10,8%), lait de consommation (11,2%), crème
(8,3%), yoghourt (3,4%) ou séré (0,8%).`}</p>
    <Image file={['milchprodukte-fr-01.png', 'milchprodukte-fr-02.png']} title='Transformation du lait de vache en Suisse' subtitle='par produits, 2017' source='Source: www.agrarbericht.ch' mdxType="Image" />
    </MDXLayout>;
}

MDXContent.isMDXComponent = true;
  